import React from 'react';
const htmlProviderTermsOfUse = require('./htmlProviderTermsOfUse.html');

export default function ProviderTermsOfUse() {
    return <div dangerouslySetInnerHTML={{ __html: htmlProviderTermsOfUse.default }} style={{ padding: 60 }} />;
}
